








import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoGallery from '@/shared/components/respondeco-gallery.vue'
import RespondecoGalleryItem from '@/shared/components/respondeco-gallery-item.vue'
import { Prop } from 'vue-property-decorator'
import PhotoSwipeGallery from '@/shared/components/photo-swipe-gallery.vue'
import { ProjectResponse } from '@/api/generated'
import { Resource } from '@/shared/interfaces/resource'

@Component({
  components: { PhotoSwipeGallery, RespondecoGalleryItem, RespondecoGallery },
})
export default class ProjectGallery extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly project!: ProjectResponse

  get gallery(): Resource[] {
    return (
      this.project.resources.filter(resource => resource.name === 'gallery')[0]?.resources ?? []
    )
  }
}
